import React from 'react'

const Footer = () => (
  <footer className="ts-footer ts-no-print">
    <div className="ts-container ts-footer__row">
      <span>Signal Card &middot; True Signal Analytics &middot; [Add contact email]</span>
      <span>
        <a href="https://invisibleillness.crowdicity.com/" target="_blank" rel="noreferrer">
          TOPx HHS Tech Sprint &middot; Lyme Innovation
        </a>
      </span>
    </div>
  </footer>
)

export default Footer
